import { css } from '@emotion/react';
// Constants
import { Color } from "../../constants/Colors";
import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, dialogClasses, backdropClasses } from '@mui/material';
export const StyledDialog = styled(Dialog)(({ nopadding, theme }) => ({
    [`& .${dialogClasses.paper}`]: {
        overflowX: 'hidden',
        opacity: 1,
        borderRadius: 0,
        boxShadow: "0px 2px 34px 0px rgba(0, 0, 0, 0.23)",
        padding: nopadding ? 0 : 24,
        zIndex: 2500,
        [theme.breakpoints.down('sm')]: {
            background: 'red',
        }
    },
    [`& .${backdropClasses.root}`]: {
        position: "fixed",
        backgroundColor: `${Color.primary[900]} !important`,
        opacity: '0.8 !important',
    }
}));
export const IconButtonDialogTitleCloseButton = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    right: 8,
    top: 8,
    color: Color.primary[900],
    "&:hover": {
        backgroundColor: "transparent",
    },
}));
export const StyledDialogTitle = styled(DialogTitle)(({ nopadding }) => ({
    margin: 0,
    padding: 0,
    paddingBottom: nopadding ? 0 : 6
}));
export const StyledTypography = styled(Typography)(({ fontFamily, size, color }) => ({
    fontFamily: fontFamily,
    fontSize: size,
    color: color
}));
export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: 0,
}));
export const useStyles = (props) => ({
    backdrop: css({
        position: 'fixed',
        backgroundColor: `${Color.primary[900]} !important`,
        opacity: '0.8 !important',
    }),
    dialogRoot: css({
        zIndex: 2500,
    }),
    dialogPaper: css({
        overflowX: 'hidden',
        opacity: 1,
        borderRadius: 0,
        boxShadow: '0px 2px 34px 0px rgba(0, 0, 0, 0.23)',
        padding: '24px',
        zIndex: 2500,
    }),
    dialogPaperNoPadding: css({
        opacity: 1,
        borderRadius: 0,
        boxShadow: '0px 2px 34px 0px rgba(0, 0, 0, 0.23)',
        zIndex: 2500,
    }),
    dialogTitleRoot: css({
        margin: 0,
        padding: 0,
        paddingBottom: '6px',
    }),
    dialogTitleRootNoPadding: css({
        margin: 0,
        padding: 0,
    }),
    header: css({
        fontFamily: 'capitolium-bold',
        fontSize: '24px',
        color: Color.neutral[900],
    }),
    overline: css({
        fontFamily: 'roboto',
        fontSize: '12px',
        color: Color.neutral[500],
    }),
    dialogTitleCloseButton: css({
        position: 'absolute',
        right: '8px',
        top: '8px',
        color: Color.primary[900],
        '&:hover': {
            backgroundColor: 'transparent',
        },
    }),
    dialogContentRoot: css({
        padding: 0,
    }),
});